module.exports = __webpack_public_path__ + "static/media/LGP-270x270.7972c865.png";